import { render, staticRenderFns } from "./viewPartnerLink.vue?vue&type=template&id=1ea86949"
import script from "./viewPartnerLink.vue?vue&type=script&lang=js"
export * from "./viewPartnerLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports